import {
  GET_ALL_COLOR_REQUEST,
  GET_ALL_COLOR_SUCCESS,
  GET_ALL_COLOR_FAILURE,
} from "./ActionType";

const initialState = {
  colors: [],
  loading: false,
  error: "",
};

export const publicColorReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case GET_ALL_COLOR_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_COLOR_SUCCESS:
      return { ...state, colors: action.payload , loading: false, error: ""};

    case GET_ALL_COLOR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
